var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFbConversationIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 25.915,
    viewBox: "0 0 26 25.915",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_743",
    x: 0,
    y: 0,
    width: 26,
    height: 25.915,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2596",
    "data-name": "Group 2596",
    transform: "translate(-298 -204)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 298, 204)",
    filter: "url(#Path_743)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_743-2",
    "data-name": "Path 743",
    d: "M14,7a7,7,0,1,0-8.094,6.915V9.023H4.129V7H5.906V5.458A2.47,2.47,0,0,1,8.55,2.734a10.659,10.659,0,0,1,1.567.138V4.595H9.235A1.012,1.012,0,0,0,8.094,5.688V7h1.941l-.31,2.023H8.093v4.89A7,7,0,0,0,14,7Z",
    transform: "translate(6 4)",
    fill: "#1877f2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_744",
    "data-name": "Path 744",
    d: "M155.087,105.3l.311-2.027h-1.946v-1.316a1.014,1.014,0,0,1,1.143-1.1h.884V99.138a10.679,10.679,0,0,0-1.57-.138,2.475,2.475,0,0,0-2.649,2.729v1.545h-1.78V105.3h1.781v4.9a7.087,7.087,0,0,0,2.192,0v-4.9Z",
    transform: "translate(158.643 111.713)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbConversationIcon);
export default __webpack_public_path__ + "static/media/fb-conversation-icon.81946fc5f4f2d49829e1b9c50a2f10fe.svg";
export { ForwardRef as ReactComponent };